const DEFAULT_INTERNAL_DOCUMENT_ADMINS = [
  "shimon@crediarc.com",
  "michal@crediarc.com",
];

export const canAccessInternalDocuments = (email, isAdmin) =>
  !!isAdmin && DEFAULT_INTERNAL_DOCUMENT_ADMINS.includes(String(email || "").trim().toLowerCase());

export { DEFAULT_INTERNAL_DOCUMENT_ADMINS };
